// extracted by mini-css-extract-plugin
export default {"loadingWrap":"loadings-module--loading-wrap--rn9JS"};